import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/agent/sanjiao_bai.png'
import _imports_1 from '@/assets/agent/sanjiao.png'


const _hoisted_1 = { class: "main_container" }
const _hoisted_2 = {
  key: 0,
  class: "dropDown"
}
const _hoisted_3 = {
  key: 1,
  class: "dropDownUp"
}

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'selectPopOver',
  emits: ['setActiveType'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const showPopover = ref(false);

const actions = ref([
    { text: t('agent.directRegistration'), id: 1 },
    { text: t('agent.commissionTeam'), id: 2 },
]);
const selectAction = ref(actions.value[0])
const emits = __emit
const onSelect = (item: any) => {
    selectAction.value = item
    emits('setActiveType', selectAction.value.id)
    setTimeout(() => { showPopover.value = false }, 200)
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popover = _resolveComponent("van-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popover, {
      id: "drop_down_id",
      show: showPopover.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopover).value = $event)),
      actions: actions.value
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_van_row, {
          class: "dropDown_container",
          style: _normalizeStyle({ border: !showPopover.value ? '1px solid rgba(255, 255, 255, 0.25)' : '1px solid rgba(255, 255, 255, 1)' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "22" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(selectAction.value.text), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "2" }, {
              default: _withCtx(() => [
                (!showPopover.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                (showPopover.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: ""
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_van_row, { class: "option_card" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (item) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                span: "24",
                class: "option_row",
                style: _normalizeStyle({ background: selectAction.value.id == item.id ? '#F0A853' : '' }),
                key: item.text,
                onClick: ($event: any) => (onSelect(item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["style", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "actions"])
  ]))
}
}

})